import { SerializedError, createSlice } from '@reduxjs/toolkit';

import { REQUEST_METHODS } from '@lib/core/service/consts';
import { createTypedAsyncThunk } from '@lib/core/service/createTypedAsyncThunk';
import { request } from '@lib/core/service/requests/request';
import { postUserFeedback } from '@lib/core/users/slices/urls';

interface IFeedbackSlice {
  isLoading: boolean;
  error: SerializedError;
}
const initialState: IFeedbackSlice = {
  error: null,
  isLoading: false,
};

export const actionPostProductFeedback = createTypedAsyncThunk(
  'products/feedback/post',
  async ({
    session,
    metadata,
    email = null,
  }: {
    session: string;
    metadata: { feedback: { liked: boolean; product: string } };
    email?: string;
  }) =>
    await request({
      body: {
        metadata,
        session,
      },
      method: REQUEST_METHODS.POST,
      url: `${postUserFeedback()}${email ? `${email}/` : ''}`,
    }),
);

const productFeedbackSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(actionPostProductFeedback.pending, state => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(actionPostProductFeedback.fulfilled, state => {
      state.isLoading = false;
    });
    builder.addCase(actionPostProductFeedback.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
  initialState,
  name: 'productFeedbackSlice',
  reducers: {
    actionResetProductFeedback: () => initialState,
  },
});

export default productFeedbackSlice.reducer;
export const { actionResetProductFeedback } = productFeedbackSlice.actions;
